<template>
  <ChartWrapper class="line-chart" :status="status">
    <svg class="root" ref="root" />
  </ChartWrapper>
</template>

<script>
import d3 from '@/utils/d3_importer'
import localeObj from '@/assets/d3-time-format-locale/es-ES'
import ChartWrapper from '@/components/IndicatorCards/parts/charts/ChartWrapper'

var moment = require('moment');
// import * as data from '@/assets/fake_data/evol_tourism_ranking.json'
export default {
  name: "LineChart",
  components:{
    ChartWrapper
  },
  props:{
    data: {
      type: Object
    },
    compareData: {
      required: false
    },
    selectedItem: {
      type: String,
      default: null
    },
    status: Object
  },

  mounted () {
    console.log(this.selectedItem)
    console.log(this.data)
    this.drawChart()

  },
  computed: {
    chartData () {
      let evolData = this.data && this.data.data && this.data.data.find(el => {  return el.id === "evol_tourism_ranking_month"})
      let evolData2 = this.compareData && this.compareData.data && this.compareData.data.find(el => {  return el.id === "evol_tourism_ranking_month"})
      if(evolData && this.isCompareMode){
        let line1 = evolData.data.find((d)=>d.id===(this.selectedItem || "iso_tourists"))
        if(line1 && evolData2){
          let line2 = {...evolData2.data.find((d)=>d.id===(this.selectedItem || "iso_tourists"))}
          line2.id=line2.id+'_compared'
          line2.compared=true
          return [line1,line2]
        } else {
          return line1 ? [line1] : null
        }
      } else if (evolData){
        return evolData.data
      } else {
        return null
      }
      
    }
  },
  watch: {
    data () {
      this.drawChart()
    },
    compareData () {
      this.drawChart()
    },
    // selectedItem () {
    //   console.log(this.selectedItem)
    //   this.drawChart()
    // }
  },
  methods: {
    //closestStart to a util maybe??
    closestStart (date, startOfStr = 'month') {
      let prev = moment(date).startOf(startOfStr)
      let next = (moment(date).startOf(startOfStr).add(1, startOfStr))
      let closest = prev
      if( date - prev > next - date )
        closest = next
      return closest
    },
    drawChart () {
      if(!this.chartData) return
      // "consts"
      let height = this.$refs.root.clientHeight
      let width = this.$refs.root.clientWidth
      let margin = {left: 10*width/100, top: 5, right: 3*width/100, bottom: 25}

      let yMax = d3.max(this.chartData.map(d => {return d3.max(d.data, dd => dd.value)}))
      let y = d3.scaleLinear().domain([0,1.1*yMax]).nice().range([height-margin.bottom,margin.top])  // d3.max(this.chartData, function(d) { return +d.value; })

      let yAxis = d3.axisLeft(y).tickFormat((d)=> d+'%').ticks(6)

      let locale = d3.timeFormatDefaultLocale(localeObj)
      //nomes tenim en compte el domain x de la primera linia de dades...
      let dates = this.chartData[0].data.map(d => {return d.valueDate})

      let mi = this.closestStart(Math.min(...dates))
      let ma = this.closestStart(Math.max(...dates))
      let x = d3.scaleTime().domain([mi,ma]).range([margin.left,width-margin.right])
      let format = locale.format("%b")
      let xAxis = d3.axisBottom(x).tickFormat(format).ticks(5)

      // root and axis
      let root = d3.select(this.$refs.root)
      let xAxisSelection = root.selectAll('.x-axis').data([null]).enter().append('g').attr('class','x-axis').attr("transform", `translate(0,${height - margin.bottom})`)
      xAxisSelection.call(xAxis)
      let yAxisSelection = root.selectAll('.y-axis').data([null]).enter().append('g').attr('class','y-axis').attr("transform", `translate(${margin.left},0)`)
      yAxisSelection.call(yAxis)


      let xGrid = root.selectAll('.grid').data([null]).enter().append('g').attr('class','x-grid')
        .attr("transform", `translate(0,${height - margin.bottom})`)
        .call(d3.axisBottom(x)
          .ticks(6)
          .tickSize(-height + margin.bottom - margin.top)
          .tickFormat("")
        )

      // actual content
      let line = d3.line()
        .curve(d3.curveCardinal.tension(0.7))
        .defined(d => !isNaN(d.value))
        .x((d) => {
          // console.log("d",d)
          return x(d.valueDate)
        })
        .y((d) => y(d.value))

      let items = root.selectAll('.item')
        .data(this.chartData, d => d.id)
      let itemsEnter = items.enter().append('g')
        .attr('class', (d) => { return 'item ' + d.id+(d.compared?' compared':'')})
      itemsEnter
        // .append('title')
        .append("path")
          .style("mix-blend-mode", null)
          .attr("fill", "none")
          .attr("stroke-width", 1.5)
          .attr("d", (d)=>line(d.data))
      items.exit().remove()
      items = items.merge(itemsEnter)
      items.select('path').attr("d", (d)=>{
        return line(d.data)
      })
      let self = this
      items
        .classed("unselected", (d) => d.id !== this.selectedItem) // No cal: && d.id != 'iso_tourists'
        .classed("selected", (d) => d.id === this.selectedItem || this.isCompareMode)
        // .raise((d) => d.id === this.selectedItem)
        .each(function(d){
          if(d.id === self.selectedItem) d3.select(this).raise()
        })
    }
  }
}
</script>

<style scoped lang="stylus">
.line-chart
  padding: 5px

  .root
    height: 100%
    width: 100%
    font-family: Lato
    font-weight: $fw-semi-bold
    m-font-size(11,13)

    >>> .x-axis
      .tick
        text-transform: uppercase
        .mobile &
          m-font-size(10,12)

    >>> .x-grid
      .domain
        display: none

      .tick
        opacity: 0.3

        line
          shape-rendering: crispEdges


    >>> .item
      &.unselected
        path
          stroke: #ddd
      &.selected
        path
          stroke: $bs-blue
      &.compared
        path
          stroke: $compare-color
      &.iso_tourists
        path
          stroke: black
          stroke-dasharray: 2
        &.selected
          path
            stroke: $bs-blue
            stroke-dasharray: none
</style>